/**
 * Calculate BMI using Imperial measurements
 *
 * @param heightFeetPortion - Feet portion of height
 * @param heightInchesPortion - Inches portion of height
 * @param weightInLbs - Weight in pounds
 * @returns BMI value
 */
export function calculateBMIImperial(
  heightFeetPortion: number,
  heightInchesPortion: number,
  weightInLbs: number,
): number {
  const heightInInches = heightFeetPortion * 12 + heightInchesPortion;
  return (weightInLbs / heightInInches ** 2) * 703;
}

/**
 * Calculate current BMI using Metric measurements
 *
 * @param heightCm - Total height in centimeters
 * @param currentWeightKg - Current weight in kilograms
 * @returns BMI value
 */
export function calculateBMIMetric(heightCm: number, currentWeightKg: number) {
  const heightInMeters = heightCm / 100;
  return currentWeightKg / (heightInMeters * heightInMeters);
}

/**
 * Calculate weight in metric units from a BMI value and height in metric units
 * <=> bmi * (heightInMeters^2) = targetWeight
 */
export function calculateImperialWeightFromBMI(
  heightFeetPortion: number,
  heightInchesPortion: number,
  bmi: number,
) {
  const heightInInches = heightFeetPortion * 12 + heightInchesPortion;
  return (bmi * heightInInches ** 2) / 703;
}
